import { render } from "./AnnotTab.vue?vue&type=template&id=99adb9ae&scoped=true"
import script from "./AnnotTab.vue?vue&type=script&lang=js"
export * from "./AnnotTab.vue?vue&type=script&lang=js"

import "./AnnotTab.vue?vue&type=style&index=0&id=99adb9ae&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99adb9ae"]])

export default __exports__